import { Subject } from 'rxjs';
import { appConstants } from '../constants';

export class SortProductsModel
{
	constructor() { }

	private _sorting: any = null;
	public _sortingChange: Subject<any> = new Subject();
	
	public get Sorting(): any {
		return this._sorting;
	}

	public get SortingName(): any {
		let nameSort = '';
		for (const key in appConstants.sortingCategories) {
			if (Object.prototype.hasOwnProperty.call(appConstants.sortingCategories, key)) {
				if (appConstants.sortingCategories[key] === this._sorting) {
					nameSort = appConstants.sortNames[key];
				}
			}
		}
		return nameSort;
	}

	public set Sorting(value: any) {
		this._sorting = value;
		this._sortingChange.next(this._sorting);
	}
}